import styles from './AssignOutletModal.css'
import {Modal} from 'react-bootstrap'
import {FieldArray, Field, formValueSelector} from 'redux-form'
import {
  checkAllOutlets, uncheckAllOutlets, searchOutlet, cancelAssignOutlets, confirmAssignOutlets
} from 'actions/employees/list'
import {connect} from 'react-redux'

const selector = formValueSelector('invite')

const _renderName = ({input: {value}}) => {
  return <p>{value}</p>
}

class OutletField extends React.Component {
  render () {
    let {member, outlet} = this.props
    return (outlet.show && <li className={styles.row}>
      <div className='col-xs-12'>
        <div className='col-xs-10'>
          <Field
            name={`${member}.name`}
            component={_renderName}
            />
        </div>
        <div className='col-xs-2'>
          <span className='pull-right'>
            <Field
              name={`${member}.checked`}
              component='input'
              type='checkbox'
            />
          </span>
        </div>
      </div>
      </li>
    )
  }
}

class OutletFieldArray extends React.Component {
  render () {
    let {fields, outlets} = this.props

    return (
      <Modal.Body bsClass={`modal-body ${styles['modal-body']}`}>
        <div className='col-md-12' style={{'margin-bottom': '20px'}}>
          <div className='right-inner-addon'>
            <i className='fa fa-search' />
            <input className='form-control' placeholder='Search' onChange={this._onChange} />
          </div>
        </div>
        <div className='col-md-12'>
          <ul>
            {fields.map((member, index) => {
              return <OutletField member={member} index={index} outlet={outlets[index]} />
            })}
          </ul>
        </div>
      </Modal.Body>
    )
  }

  _onChange = (e) => {
    let {dispatch, outlets} = this.props
    const value = e.target.value
    dispatch(searchOutlet(outlets, 'invite', 'outlets', value))
  }
}

// function mapStateToOutletFieldArrayProps(state){
//   return {
//     data: {
//       inviteForm: {
//         outlets: selector(state,'outlets')
//       }
//     }
//   }
// }

OutletFieldArray.propTypes = {
  dispatch: React.PropTypes.func
}

class AssignOutletModal extends React.Component {
  render () {
    let {showAssignOutletModal} = this.props.data.employee.list
    return (<Modal show={showAssignOutletModal} dialogClassName={styles['modal-dialog']}>
      <Modal.Header bsClass={`modal-header ${styles.header}`}>
        Assign Outlet To Employee
      </Modal.Header>
      <FieldArray
        name='outlets'
        component={OutletFieldArray}
        outlets={this.props.data.inviteForm.outlets}
        dispatch={this.props.dispatch}
      />
      <Modal.Footer>
        <span className='pull-left'>
          <button onClick={this._onCancel} className='btn btn-default'>Cancel</button>
          <button className='btn btn-success' onClick={this._onClickCheckAll}>Check All</button>
          <button className='btn btn-danger' onClick={this._onClickUncheckAll}>Uncheck All</button>
        </span>
        <span className='pull-right'>
          <button onClick={this._onConfirm} className='btn btn-primary'>Assign to Employee</button>
        </span>
      </Modal.Footer>
    </Modal>)
  }

  // _onHide = () => {
  //   this.props.dispatch(hideAssignOutletModal())
  // };

  _onCancel = () => {
    let {checkedOutlets} = this.props.data.employee.list
    this.props.dispatch(cancelAssignOutlets(checkedOutlets, 'invite', 'outlets'))
  };

  _onConfirm = () => {
    let {outlets} = this.props.data.inviteForm
    this.props.dispatch(confirmAssignOutlets(outlets))
  }

  _onClickCheckAll = () => {
    let {outlets} = this.props.data.inviteForm
    this.props.dispatch(checkAllOutlets(outlets, 'invite', 'outlets'))
  };

  _onClickUncheckAll = () => {
    let {outlets} = this.props.data.inviteForm
    this.props.dispatch(uncheckAllOutlets(outlets, 'invite', 'outlets'))
  }
}

AssignOutletModal.propTypes = {
  dispatch: React.PropTypes.func
}

function mapStateToProps (state) {
  return {
    data: {
      inviteForm: {
        outlets: selector(state, 'outlets')
      },
      employee: {
        list: state.employee.list
      }
    }
  }
}

export default connect(mapStateToProps)(AssignOutletModal)



// WEBPACK FOOTER //
// ./app/pages/Employees/List/InviteForm/AssignOutletModal/AssignOutletModal.js